document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[data-sabar-ingredients]').forEach(function(section){
    const buttons = section.querySelectorAll('[data-filter]');
    const cards = section.querySelectorAll('[data-category]');
    buttons.forEach(function(btn){
      btn.addEventListener('click', function(){
        const filter = btn.getAttribute('data-filter');
        buttons.forEach(b => b.classList.toggle('is-active', b === btn));
        cards.forEach(function(card){
          const cats = (card.getAttribute('data-category') || '').split(' ');
          card.classList.toggle('is-hidden', filter !== 'all' && !cats.includes(filter));
        });
      });
    });
  });

  document.querySelectorAll('[data-sabar-gallery]').forEach(function(gallery){
    const main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function(btn){
      btn.addEventListener('click', function(){
        if(main) main.src = btn.getAttribute('data-src');
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
      });
    });
  });

  document.querySelectorAll('[data-sabar-product-form]').forEach(function(formWrap){
    const form = formWrap.querySelector('form');
    if(!form) return;
    const qtyInput = form.querySelector('[name="quantity"]');
    const bundleEls = formWrap.querySelectorAll('[data-bundle-qty]');
    const stickyPrice = document.querySelector('[data-sticky-price]');
    function selectBundle(bundle){
      bundleEls.forEach(b => b.classList.remove('is-selected'));
      bundle.classList.add('is-selected');
      if(qtyInput) qtyInput.value = bundle.getAttribute('data-bundle-qty');
      if(stickyPrice) stickyPrice.textContent = bundle.getAttribute('data-bundle-display');
    }
    bundleEls.forEach(function(bundle){
      bundle.addEventListener('click', function(){ selectBundle(bundle); });
      bundle.addEventListener('keydown', function(e){
        if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); selectBundle(bundle); }
      });
    });
    const stickyButton = document.querySelector('[data-sticky-submit]');
    if(stickyButton){
      stickyButton.addEventListener('click', function(){
        const submit = form.querySelector('[type="submit"]');
        if(submit && !submit.disabled) submit.click();
      });
    }
  });

  document.querySelectorAll('[data-faq-q]').forEach(function(btn){
    btn.addEventListener('click', function(){
      const item = btn.closest('.sabar-faq-item');
      const open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      const plus = btn.querySelector('.sabar-faq-plus');
      if(plus) plus.textContent = open ? '−' : '+';
    });
  });
});
